// Geocoding utility using OpenStreetMap Nominatim (free, no API key required)

const NOMINATIM_URL = 'https://nominatim.openstreetmap.org';

/**
 * Geocode an address to get latitude and longitude
 * @param {string} address - The address to geocode
 * @returns {Promise<{lat: number, lng: number} | null>} - Coordinates or null if not found
 */
export async function geocodeAddress(address) {
  if (!address || !address.trim()) {
    return null;
  }

  try {
    // Add Asheville, NC as a hint for better results
    const searchQuery = address.toLowerCase().includes('asheville') 
      ? address 
      : `${address}, Asheville, NC`;

    const response = await fetch(
      `${NOMINATIM_URL}/search?` + new URLSearchParams({
        q: searchQuery,
        format: 'json',
        limit: 1,
        countrycodes: 'us',
      }),
      {
        headers: {
          'User-Agent': 'AVLFlavor-FoodTruckApp/1.0',
        },
      }
    );

    if (!response.ok) {
      throw new Error('Geocoding request failed');
    }

    const data = await response.json();

    if (data && data.length > 0) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      };
    }

    return null;
  } catch (error) {
    console.error('Geocoding error:', error);
    throw error;
  }
}

/**
 * Reverse geocode coordinates to get an address
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<string | null>} - Address or null if not found
 */
export async function reverseGeocode(lat, lng) {
  try {
    const response = await fetch(
      `${NOMINATIM_URL}/reverse?` + new URLSearchParams({
        lat: lat.toString(),
        lon: lng.toString(),
        format: 'json',
      }),
      {
        headers: {
          'User-Agent': 'AVLFlavor-FoodTruckApp/1.0',
        },
      }
    );

    if (!response.ok) {
      throw new Error('Reverse geocoding request failed');
    }

    const data = await response.json();

    if (data && data.display_name) {
      return data.display_name;
    }

    return null;
  } catch (error) {
    console.error('Reverse geocoding error:', error);
    return null;
  }
}
